module.exports = __webpack_public_path__ + "img/beautiful.be5030ca.webp";